var ctrlopt = ctrlopt,
  generic = generic || {},
  site = site || {},
  FB = FB || '';

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings.globals_variables || {};
  var oab_legal_statement_promotions =
    Drupal.settings.globals_variables.oab_legal_statement_promotions || 0;
  var kr_registration = Drupal.settings.globals_variables.kr_registration || 0;
  var reg_form_name = Drupal.settings.globals_variables.reg_form_name || 'registration_short';
  var ommit_sms = settings.appointment_booking_ignore_sms || 0;
  var oab_privacy_mandatory = settings.oab_privacy_mandatory || 0;
  var oab_email_promotions = settings.oab_email_promotions || 0;

  /* Concrete View */
  apptBook.confirmAccount = function (container) {
    apptBook.confirmAccount.superclass.constructor.call(this);
    this.id = 'confirm';
    this.jqBod = $('body');
    this.container = container;
    this.signInContainer = container.find('.sign-in-container');
    this.bookContainer = container.find('.book-appt-container');
    this.confContainer = container.find('.booking-container');
    this.startOver = this.bookContainer.find('.start-over');
    this.selErrOverlay = container.find('.appt-book-services-overlay').remove();
    this.bookConflictOverlay = container.find('.appt-book-book-conflict-overlay').remove();
    this.calendarId = '0';
    this.appointmentId = null;
    this.serviceIds = [];
    this.updateMode = false;
  };

  ctrlopt.extend(apptBook.confirmAccount, apptBook.AbstractSection);

  apptBook.confirmAccount.prototype.onUpdate = function (data) {
    var servs,
      servObj,
      hasCounter = false,
      hasCounters = false,
      me = this,
      aPgName = document.title + ' - Confirm Account & Book';

    this.serviceIds = [];
    this.updateMode = false;

    function runUpdate() {
      if (hasCounter && hasCounters) {
        me.buildBookAppt();
      }
    }

    function processUpdate() {
      if (data.params.appointmentId) {
        me.model.getAppointment(
          data.params.appointmentId,
          function (apptData) {
            me.updateMode = true;
            me.counterId = data.params.counterId;
            me.calendarId = data.params.calendarId;
            me.serviceIds = data.params.serviceIds;
            me.appointmentId = apptData.id;
            me.startTime = data.params.startTime;

            me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
              me.counterData = data;
              hasCounter = true;
              runUpdate();
            });
          },
          function () {
            // If there is an error retrieving appointment id, go to beginning of APP
            var myUrl = [location.protocol, '//', location.host, location.pathname].join('');

            window.location = myUrl;
          }
        );
      } else {
        me.counterId = data.params.counterId;
        me.startTime = data.params.startTime;
        me.calendarId = data.params.calendarId;
        me.serviceIds = data.params.serviceIds;
        me.services = data.params.services;
        me.model.getCounter(me.counterId, { service_id: me.serviceIds }, function (data) {
          me.counterData = data;
          hasCounter = true;
          runUpdate();
        });
      }

      me.model.fetchCountersData({ service_id: this.serviceIds }, function (data) {
        me.countersData = data;
        hasCounters = true;
        runUpdate();
      });
    }

    if (data.sectionId === this.id) {
      generic.jsonrpc.fetch({
        method: 'user.json',
        // params: [],
        onSuccess: function (jsonRpcResponse) {
          me.userData = jsonRpcResponse.getValue();
          processUpdate();
        },
        onFailure: function (jsonRpcResponse) {
          me.userData = null;
          processUpdate();
        }
      });
    }
  };

  apptBook.confirmAccount.prototype.buildBookAppt = function () {
    var totText,
      me = this,
      signIn = this.signInContainer.find('#appt-book-sign-in-form-container'),
      signInLinkContainer = this.signInContainer.find('.sign-in-link-container'),
      signInLink = this.signInContainer.find('#appt-book-sign-in-link').off('click'),
      guestLinkContainer = this.signInContainer.find('.guest-link-container'),
      guestLink = this.signInContainer.find('#appt-book-guest-link').off('click'),
      loginEmail = this.signInContainer.find('#appt-book-login-email'),
      pw = this.signInContainer.find('#appt-book-login-password'),
      forgotPasswordLink = this.signInContainer.find('.js-forgot-password').off('click'),
      hiddenForm = this.signInContainer.find('.js-signin-hidden-form'),
      signInBtn = signIn.find('#appt-book-login-submit').off('click'),
      fbsignInBtn = signIn.find('#appt-book-fblogin-submit').off('click'),
      bookBtn = this.confContainer.find('#appt-book-book-submit'), // .off('click'),
      guestLinkText = this.bookContainer.find('.guest-link-text'),
      fNameInput = this.bookContainer.find('.appt-book-first-name'),
      lNameInput = this.bookContainer.find('.appt-book-last-name'),
      emailInput = this.bookContainer.find('.appt-book-email'),
      phoneInput = this.bookContainer.find('.appt-book-mobile'),
      checkboxInput = this.bookContainer.find('input[type=checkbox]'),
      rPassContainer = this.bookContainer.find('.signin-block__field-wrapper.login-password'),
      rpw = this.bookContainer.find('#appt-book-register-password'),
      signUpEmailInput = this.bookContainer.find('.registration__email-list').find('input'),
      signUpSMSInput = this.bookContainer.find('.registration__sms-list').find('input'),
      signUpPrivacyInput = this.bookContainer.find('.registration__privacy-list').find('input'),
      signUpPrivacyContainer = this.bookContainer.find('.registration__privacy_policy-container'),
      errorContainer = this.container.find('#appt-book-confirm-error-messages'),
      errorMessages = errorContainer.find('.error-message'),
      signInHeight,
      drupal = Drupal || {},
      settings = drupal.settings || {},
      apptBookingHelpers = this.bookContainer.find('.appt_booking_helpers'),
      krFormat = apptBookingHelpers.data('appt-use-kr-mobile-number-fields'),
      termsPrivacyRadio = this.bookContainer.find('.appt-book-oab-legal-privacy'),
      termsSMSNotificationsRadio = this.bookContainer.find('.enable_sms_notifications'),
      termsEmailPromotionsRadio = this.bookContainer.find('.appt-book-oab-email-promotions'),
      termsSMSPromotionsRadio = this.bookContainer.find('.enable_sms_promotions'),
      termsPostalRadio = this.bookContainer.find('.appt-book-oab-postal'),
      termsThirdPartyPromotionRadio = this.bookContainer.find('.appt-book-third-party'),
      termsPrivacyRadioLabel = this.bookContainer.find('.accept-terms-head'),
      termsSMSNotificationsRadioLabel = this.bookContainer.find('.accept-sms-notification-head'),
      termsEmailPromotionsRadioLabel = this.bookContainer.find('.accept-email-head'),
      termsSMSPromotionsRadioLabel = this.bookContainer.find('.accept-sms-head'),
      termsPostalRadioLabel = this.bookContainer.find('.accept-postal-head'),
      termsThirdPartyPromotionRadioLabel = this.bookContainer.find('.accept-thirdparty-head'),
      countryCode = apptBookingHelpers.length
        ? apptBookingHelpers.data('country-code') || ''
        : this.bookContainer.data('country-code') || '',
      phone1Input,
      phone2Input,
      apptKrSelectPhoneCode,
      apptKRPhoneCode,
      mobileParts,
      populateKRPhoneField,
      sms_enabled = this.bookContainer.data('enableSms');

    if (krFormat) {
      phone1Input = this.bookContainer.find('.js_appt_mobile_part1');
      phone2Input = this.bookContainer.find('.js_appt_mobile_part2');
      apptKRPhoneCode = this.bookContainer.find('.js_appt_kr_phone_code');
      var apptPhoneCode = apptBookingHelpers.data('appt-phone-codes');

      if (apptKRPhoneCode.length === 2) {
        // remove incorrectly generated JS selectbox, as it contains only one option
        apptKRPhoneCode.first().remove();
      }
      apptKrSelectPhoneCode = this.bookContainer.find('select.js_appt_kr_phone_code');
      var apptPhoneCodeSplit = apptPhoneCode.split(',');
      var codeOptions;

      $.each(apptPhoneCodeSplit, function (i, val) {
        codeOptions = $('<option></option>', {
          value: val,
          text: val
        });
        apptKRPhoneCode.append(codeOptions);
      });
      // reinitialize selectbox
      $(document).trigger('selectBox.initOne', [apptKrSelectPhoneCode]);
      phoneInput.keydown(function (e) {
        var key = e.charCode || e.keyCode || 0;

        return (
          key === 8 ||
          key === 9 ||
          key === 46 ||
          (key >= 48 && key <= 57) ||
          (key >= 96 && key <= 105)
        );
      });
    }

    if (settings.fb_login_app_id && site.facebook && typeof FB === 'object') {
      site.facebook.init();
      if (site.client.isMobile) {
        signInHeight = 540; // mobile
      } else {
        signInHeight = 400; // pc
      }
    }

    $(window).on('loadPreviousApptObjBackButton', function () {
      var upObj = {
        sectionId: 'appointments',
        params: {
          sectionId: me.id,
          counterId: me.counterId,
          calendarId: me.calendarId,
          serviceIds: me.serviceIds,
          services: me.services,
          appointmentId: me.appointmentId,
          startTime: me.startTime,
          initialized: false
        }
      };

      return upObj;
    });

    if (me.userData.signed_in) {
      guestLinkText.addClass('hidden');
    }

    var passwordInput = this.bookContainer.find('.register__password');

    this.startOver.off('click');

    fNameInput.placeholder();
    fNameInput.value = fNameInput.attr('placeholder');
    fNameInput.addClass('appt-placeholder');

    lNameInput.placeholder();
    lNameInput.value = lNameInput.attr('placeholder');
    lNameInput.addClass('appt-placeholder');

    emailInput.placeholder();
    emailInput.value = emailInput.attr('placeholder');
    emailInput.addClass('appt-placeholder');

    phoneInput.placeholder();
    phoneInput.value = phoneInput.attr('placeholder');
    phoneInput.addClass('appt-placeholder');

    passwordInput.placeholder();
    passwordInput.value = passwordInput.attr('placeholder');
    passwordInput.addClass('appt-placeholder');

    loginEmail.placeholder();
    loginEmail.value = loginEmail.attr('placeholder');
    loginEmail.addClass('appt-placeholder');

    pw.placeholder();
    pw.value = pw.attr('placeholder');
    pw.addClass('appt-placeholder');

    fNameInput.keyup(function (e) {
      var maxlength = fNameInput.attr('data-placeholder-maxlength');

      if (!!maxlength) {
        var text = fNameInput.val();

        if (text.length > maxlength) {
          fNameInput.val(text.substring(0, maxlength));
          e.preventDefault();
        }
      }
    });

    lNameInput.keyup(function (e) {
      var maxlength = lNameInput.attr('data-placeholder-maxlength');

      if (!!maxlength) {
        var text = lNameInput.val();

        if (text.length > maxlength) {
          lNameInput.val(text.substring(0, maxlength));
          e.preventDefault();
        }
      }
    });

    phoneInput.keydown(function (e) {
      var key = e.charCode || e.keyCode || 0;

      // Allow numeric (and tab, add, backspace, delete) keys only
      return (
        key === 8 ||
        key === 9 ||
        key === 107 ||
        (key === 187 && e.shiftKey) || // add
        key === 46 ||
        (key >= 48 && key <= 57) ||
        (key >= 96 && key <= 105)
      );
    });

    phoneInput.keyup(function (e) {
      var $this = $(this);
      var maxlength = $this.attr('data-placeholder-maxlength');

      if (!!maxlength) {
        var text = $this.val();

        if (text.length > maxlength) {
          $this.val(text.substring(0, maxlength));
          e.preventDefault();
        }
      }
    });

    loginEmail.val('');
    pw.val('');
    rpw.val('');
    emailInput.val('').removeAttr('disabled');

    populateKRPhoneField = function (mobilePhone) {
      mobileParts = (/^(\d{3})-?(\d{4})-?(\d*)$/gu).exec(mobilePhone);
      if (mobileParts && mobileParts[1] && mobileParts[2] && mobileParts[3]) {
        apptKRPhoneCode.val(mobileParts[1]);
        apptKRPhoneCode.trigger('select');
        phone1Input.val(mobileParts[2]);
        phone2Input.removeClass('adpl__mode-placeholder').addClass('adpl__mode-label');
        phone2Input.val(mobileParts[3]);
        phone1Input.removeClass('adpl__mode-placeholder').addClass('adpl__mode-label');
      }
    };

    if (this.userData && this.userData.signed_in) {
      this.signInContainer.css('display', 'none');

      rpw.attr('disabled', 'disabled');
      rPassContainer.css('display', 'none');
      bookBtn.removeClass('disabled');

      if (this.userData.first_name) {
        fNameInput.val(this.userData.first_name);
        fNameInput.removeClass('adpl__mode-placeholder').addClass('adpl__mode-label');
      }

      if (this.userData.last_name) {
        lNameInput.val(this.userData.last_name);
        lNameInput.removeClass('adpl__mode-placeholder').addClass('adpl__mode-label');
      }

      if (this.userData.pc_email_address) {
        emailInput.val(this.userData.pc_email_address).attr('disabled', 'disabled');
        emailInput.removeClass('adpl__mode-placeholder').addClass('adpl__mode-label');
      }

      if (this.userData.mobile_phone) {
        if (krFormat) {
          populateKRPhoneField(this.userData.mobile_phone);
        } else {
          phoneInput.val(this.userData.mobile_phone);
          phoneInput.removeClass('adpl__mode-placeholder').addClass('adpl__mode-label');
        }
      }
    } else {
      this.signInContainer.css('display', 'block');
      this.bookContainer.addClass('guest');
    }

    signUpPrivacyContainer.find('label a').on('tap click', function (e, data) {
      e.stopPropagation();
      e.preventDefault();
      window.open($(this).attr('href'), $(this).attr('target'));

      return false;
    });
    signInLink.on('click', function (e) {
      e.preventDefault();
      var h;

      errorMessages.css('display', 'none');
      errorContainer.css('display', 'none');
      me.container.find('input, textarea, .label, .picker-handle').removeClass('error');
      guestLinkContainer.css('display', 'block');
      signInLinkContainer.css('display', 'none');
      rpw.val('').attr('disabled', 'disabled');
      me.bookContainer.removeClass('guest');
      me.bookContainer.css('display', 'none');
      bookBtn.css('display', 'none');

      signIn.css('display', 'block');
      h = signInHeight || signIn.css('height');
      signInHeight = h;
      signIn.height(0);
      signIn.animate({ height: h }, 1000, function () {
        setSignIn();
      });
    });

    forgotPasswordLink.on('click', function (e) {
      e.preventDefault();

      // Reset the Error messages
      errorMessages.css('display', 'none');
      errorContainer.css('display', 'none');
      me.container.find('input, textarea, .label, .picker-handle').removeClass('error');

      email = loginEmail.val(); // Take the Signin Email field value.
      actionURL = forgotPasswordLink.attr('href');

      if (!hiddenForm || !actionURL) {
        return null;
      }
      if (!email) {
        errorContainer.css('display', 'block');
        loginEmail.addClass('error');
        errorMessages.filter('#error-signin-email').css('display', 'block');

        return null;
      }

      var hiddenEmailNode = hiddenForm.find('.js-hidden-email');

      hiddenEmailNode.val(email);

      var hiddenReturnNode = hiddenForm.find('.js-hidden-return'),
        returnURL = window.location.pathname;

      hiddenReturnNode.val(returnURL);

      hiddenForm.submit();
    });
    guestLink.on('click', function (e) {
      e.preventDefault();
      var h;

      errorMessages.css('display', 'none');
      errorContainer.css('display', 'none');
      me.container.find('input, textarea, .label, .picker-handle').removeClass('error');
      guestLinkContainer.css('display', 'none');
      signInLinkContainer.css('display', 'block');
      rpw.val('').removeAttr('disabled');
      me.bookContainer.addClass('guest');
      me.bookContainer.css('display', 'block');
      bookBtn.css('display', 'block');

      signIn.css('display', 'none');
      h = signInHeight;
      signIn.height(h);
      signIn.animate({ height: 0 }, 1000, function () {
        setSignIn();
      });
    });
    window.fbsignInBtn = fbsignInBtn;

    function setSignIn() {
      fbsignInBtn.click(function () {
        var token = null,
          $this = $(this),
          params = [],
          last_source = null,
          pc_email_promotions = 0,
          $optInFormInput = $('#form--facebook_signin--field--PC_EMAIL_PROMOTIONS');

        if ($this.hasClass('disabled')) {
          return;
        }

        last_source = 'appointment_booking';
        pc_email_promotions = $optInFormInput.is(':checked') ? 1 : 0;

        FB.getLoginStatus(function (response) {
          statusChangeCallback(response);
        });

        function statusChangeCallback(response) {
          if (FB.getAuthResponse()) {
            token = response.authResponse.accessToken;
            rpccall();
          }
        }
        function rpccall() {
          $this.addClass('disabled');
          params.push({
            _SUBMIT: 'facebook_signin',
            token: token,
            LAST_SOURCE: last_source,
            PC_EMAIL_PROMOTIONS: pc_email_promotions
          });

          generic.jsonrpc.fetch({
            method: 'rpc.form',
            params: JSON.stringify(params),
            onSuccess: function (jsonRpcResponse) {
              var h,
                rData = jsonRpcResponse.getData().userinfo;

              me.model.updateAuthToken(function () {
                $this.removeClass('disabled');
                emailInput.val(rData.email_address).attr('disabled', 'disabled');
                if (rData.first_name) {
                  fNameInput.val(rData.first_name);
                }
                if (rData.last_name) {
                  lNameInput.val(rData.last_name);
                }
                if (rData.mobile_phone) {
                  phoneInput.val(rData.mobile_phone);
                }

                fNameInput.focus();
                lNameInput.focus();
                emailInput.focus();
                phoneInput.focus();

                me.userData = rData;
              });

              errorContainer.css('display', 'none');
              errorMessages.css('display', 'none');
              pw.removeClass('error');
              loginEmail.removeClass('error');

              $this.removeClass('disabled');

              signInLink.css('display', 'inline-block');
              bookBtn.removeClass('disabled');

              rpw.val('').attr('disabled', 'disabled');
              rPassContainer.css('display', 'none');

              me.bookContainer.css('display', 'block');
              bookBtn.css('display', 'inline-block');

              guestLinkText.addClass('hidden');

              h = signIn.css('height');
              signIn.animate({ height: 0 }, 1000, function () {
                signIn.css('display', 'none');
                signIn.addClass('hidden');
                signIn.height(h);
                me.bookContainer.removeClass('guest');
                me.signInContainer.css('display', 'none');
              });
            },
            onFailure: function (jsonRpcResponse) {
              var errObjs = jsonRpcResponse.getMessages();

              errorContainer.css('display', 'block');
              errorMessages.css('display', 'none');
              pw.removeClass('error');
              me.bookContainer.addClass('guest');
              loginEmail.removeClass('error');

              for (var i = 0; i < errObjs.length; i += 1) {
                var myErr = errObjs[i];

                if (myErr && myErr.key) {
                  if (
                    myErr.key === 'required.password.signin' ||
                    myErr.key === 'required.password.signin.app'
                  ) {
                    pw.addClass('error');
                    errorMessages.filter('#error-signin-password').css('display', 'block');
                  }

                  if (
                    myErr.key === 'invalid.password.signin' ||
                    myErr.key === 'invalid.password.signin.app'
                  ) {
                    pw.addClass('error');
                    errorMessages.filter('#error-signin-invalid-password').css('display', 'block');
                  }

                  if (
                    myErr.key === 'required_or.device_id.login_id.required_or.signin' ||
                    myErr.key === 'required_or.email_address.device_id.required_or.signin' ||
                    myErr.key === 'required_or.email_address.device_id.required_or.signin.app'
                  ) {
                    loginEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }

                  if (
                    myErr.key === 'required.email_address.signin' ||
                    myErr.key === 'required.email_address.signin.app'
                  ) {
                    loginEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }

                  if (
                    myErr.key === 'invalid.email_address.signin' ||
                    myErr.key === 'invalid.email_address.signin.app'
                  ) {
                    loginEmail.addClass('error');
                    errorMessages.filter('#error-signin-email').css('display', 'block');
                  }

                  if (
                    myErr.key === 'no_account..signin' ||
                    myErr.key === 'no_account..signin.app'
                  ) {
                    loginEmail.addClass('error');
                    pw.addClass('error');
                    errorMessages.filter('#error-signin-no-account').css('display', 'block');
                  }

                  if (myErr.key === 'account_lockout' || myErr.key === 'account_lockout.app') {
                    errorMessages.filter('#error-signin-account-lockout').css('display', 'block');
                  }

                  if (
                    myErr.key === 'social_fb_no_email' ||
                    myErr.key === 'social_fb_no_email.app'
                  ) {
                    errorMessages.filter('#error-others').css('display', 'block').text(myErr.text);
                  }

                  if (
                    myErr.key === 'social_duplicate_account_links' ||
                    myErr.key === 'social_duplicate_account_links.app'
                  ) {
                    errorMessages.filter('#error-others').css('display', 'block').text(myErr.text);
                  }

                  if (myErr.key === 'signin_error2' || myErr.key === 'signin_error2.app') {
                    errorMessages.filter('#error-others').css('display', 'block').text(myErr.text);
                  }
                }
              }
              $this.removeClass('disabled');
            }
          });
        }
      });

      signInBtn.click(function (e) {
        e.preventDefault();
        var $this = $(this),
          params = [];

        if ($this.hasClass('disabled')) {
          return;
        }

        $this.addClass('disabled');
        params.push({
          _SUBMIT: 'signin',
          EMAIL_ADDRESS: loginEmail.val(),
          PASSWORD: pw.val()
        });

        generic.jsonrpc.fetch({
          method: 'rpc.form',
          params: JSON.stringify(params),
          onSuccess: function (jsonRpcResponse) {
            var h,
              rData = jsonRpcResponse.getData().userinfo;

            me.model.updateAuthToken(function () {
              $this.removeClass('disabled');
              emailInput.val(rData.email_address).attr('disabled', 'disabled');

              if (rData.first_name) {
                fNameInput.val(rData.first_name);
              }
              if (rData.last_name) {
                lNameInput.val(rData.last_name);
              }
              if (rData.mobile_phone) {
                if (krFormat) {
                  populateKRPhoneField(rData.mobile_phone);
                } else {
                  phoneInput.val(rData.mobile_phone);
                }
              }

              fNameInput.focus();
              lNameInput.focus();
              emailInput.focus();
              phoneInput.focus();

              me.userData = rData;
            });

            errorContainer.css('display', 'none');
            errorMessages.css('display', 'none');
            pw.removeClass('error');
            loginEmail.removeClass('error');

            $this.removeClass('disabled');

            signInLink.css('display', 'inline-block');
            bookBtn.removeClass('disabled');

            rpw.val('').attr('disabled', 'disabled');
            rPassContainer.css('display', 'none');

            me.bookContainer.css('display', 'block');
            bookBtn.css('display', 'inline-block');

            guestLinkText.addClass('hidden');

            h = signIn.css('height');
            signIn.animate({ height: 0 }, 1000, function () {
              signIn.css('display', 'none');
              signIn.height(h);
              me.bookContainer.removeClass('guest');
              me.signInContainer.css('display', 'none');
            });
          },
          onFailure: function (jsonRpcResponse) {
            var errObjs = jsonRpcResponse.getMessages();

            errorContainer.css('display', 'block');
            errorMessages.css('display', 'none');
            pw.removeClass('error');
            me.bookContainer.addClass('guest');
            loginEmail.removeClass('error');

            for (var i = 0; i < errObjs.length; i += 1) {
              var myErr = errObjs[i];

              if (myErr && myErr.key) {
                if (
                  myErr.key === 'required.password.signin' ||
                  myErr.key === 'required.password.signin.app'
                ) {
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-password').css('display', 'block');
                }

                if (
                  myErr.key === 'invalid.password.signin' ||
                  myErr.key === 'invalid.password.signin.app'
                ) {
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-invalid-password').css('display', 'block');
                }

                if (myErr.key === 'format.password.signin') {
                  pw.addClass('error');
                  errorMessages.filter('#error-register-min-max-password').css('display', 'block');
                }

                if (
                  myErr.key === 'required_or.email_address.device_id.required_or.signin' ||
                  myErr.key === 'required_or.email_address.device_id.required_or.signin.app'
                ) {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (
                  myErr.key === 'required.email_address.signin' ||
                  myErr.key === 'required.email_address.signin.app'
                ) {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (
                  myErr.key === 'invalid.email_address.signin' ||
                  myErr.key === 'invalid.email_address.signin.app'
                ) {
                  loginEmail.addClass('error');
                  errorMessages.filter('#error-signin-email').css('display', 'block');
                }

                if (myErr.key === 'no_account..signin' || myErr.key === 'no_account..signin.app') {
                  loginEmail.addClass('error');
                  pw.addClass('error');
                  errorMessages.filter('#error-signin-no-account').css('display', 'block');
                }
                if (myErr.key === 'account_lockout' || myErr.key === 'account_lockout.app') {
                  errorMessages.filter('#error-signin-account-lockout').css('display', 'block');
                }
              }
            }

            $this.removeClass('disabled');
            generic.focusErrors($('.js-error-messages'), signIn);
          }
        });
      });
    }

    bookBtn.click(onSubmitBooking);

    function onSubmitBooking(e) {
      e.preventDefault();
      var params = {},
        signUpEmailParams = [],
        signUpEmailObj = {},
        isEmptyField = 0,
        fName = fNameInput.val(),
        lName = lNameInput.val(),
        email = emailInput.val(),
        phone = phoneInput.val(),
        signUpEmail = signUpEmailInput.is(':checked') ? signUpEmailInput.val() : '',
        signUpSMS = 0,
        signUpPrivacy = signUpPrivacyInput.is(':checked') ? signUpPrivacyInput.val() : '',
        signUpEmailDone = false,
        signUpSMSDone = false,
        oabTermsEmailPromotionsRadio = termsEmailPromotionsRadio.is(':checked')
          ? $('input[name=PC_EMAIL_PROMOTIONS]:checked').val()
          : 0,
        oabTermsSMSPromotionsRadio = termsSMSPromotionsRadio.is(':checked')
          ? $('input[name=SMS_PROMOTIONS]:checked').val()
          : 0,
        oabTermsPostalRadio = termsPostalRadio.is(':checked')
          ? $('input[name=POSTAL_PROMOTIONS]:checked').val()
          : 0,
        oabTermsThirdPartyPromotionRadio = termsThirdPartyPromotionRadio.is(':checked')
          ? $('input[name=ACCEPTED_THIRD_PARTY]:checked').val()
          : 0,
        $this = $(this),
        isArray = me.serviceIds instanceof Array,
        phone_full_length,
        phone_zero_length_regex,
        oabSMSOptin = $('input[name=APPT_SMS_NOTIFICATIONS]'),
        requireTermsForSMS = oabSMSOptin.length ? 1 : 0,
        oabSMSOptinValue;

      window.apptBookFirstName = fName; // Need to save this because if the user is not logged in we won't be able to get their first name from their user data.

      if ($this.hasClass('disabled')) {
        return;
      }
      errorContainer.css('display', 'block');
      $('html, body').animate(
        {
          scrollTop: $('body').offset().top
        },
        800
      );
      errorMessages.css('display', 'none');
      me.container.find('input, textarea, .label, .picker-handle').removeClass('error');
      emptyInputs();
      if (isEmptyField) {
        $this.removeClass('disabled');
        generic.focusErrors(errorContainer, $('.js-booking-step3'));

        return;
      }

      $this.addClass('disabled');

      site?.track?.evtLink && site.track.evtLink({
        event_name: 'appointmentBooking_bookNow',
        event_category: 'appointment booking',
        event_action: 'bookNow',
        event_label: me.counterData.store_no + ' - ' + me.counterData.name + ' - ' + me.startTime
      });

      params = {
        _TOKEN: '',
        counter_id: me.counterId,
        calendar_id: me.calendarId,
        appointment_service_id: me.serviceIds,
        start_time: me.startTime,
        customer_first_name: fName,
        customer_last_name: lName,
        customer_email: email
      };

      if (phone) {
        if (krFormat) {
          var area_code = apptKrSelectPhoneCode.val();

          if (area_code) {
            area_code = area_code.substr(1, 2);
          }
          params.customer_phone = countryCode + area_code + phone1Input.val() + phone2Input.val();
        } else {
          // making sure we pass phone number stripped from any dashes, brackets and leading zeros
          params.customer_phone = phone.replace(/\(|\)|-/gi, '');
          params.customer_phone = params.customer_phone.replace(/^(0)(\d+)$/, '$2');
          params.customer_phone = countryCode + params.customer_phone;
        }
      }

      if (requireTermsForSMS) {
        if (oabSMSOptin.attr('type') === 'checkbox') {
          oabSMSOptinValue = oabSMSOptin.is(':checked') ? 1 : 0;
        } else {
          oabSMSOptinValue = oabSMSOptin.is(':checked') ? oabSMSOptin.filter(':checked').val() : 0;
        }
      }
      if (sms_enabled) {
        if (requireTermsForSMS) {
          params.sms_notifications_enabled = parseInt(oabSMSOptinValue);
        } else {
          params.sms_notifications_enabled = 1;
        }
      }

      function emptyInputs() {
        var testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
        var phone_maxlength = phoneInput.attr('maxlength');
        var phone_regex = new RegExp(phoneInput.attr('pattern'));
        var phone1_regex, phone2_regex;

        if (krFormat) {
          phone1_regex = new RegExp(phone1Input.attr('pattern'));
          phone2_regex = new RegExp(phone2Input.attr('pattern'));
          phone_full_length = phone1Input.val() + phone2Input.val();
          phone_zero_length_regex = /^(?!0+$)\d{7,8}$/;
        }

        if (!fNameInput.val()) {
          errorMessages.filter('#error-book-first-name').css('display', 'block');
          fNameInput.addClass('error');
          isEmptyField = 1;
        }
        if (!$(lNameInput.parent()).hasClass('no-last-name') && !lNameInput.val()) {
          errorMessages.filter('#error-book-last-name').css('display', 'block');
          lNameInput.addClass('error');
          isEmptyField = 1;
        }
        if (!emailInput.val() || !testEmail.test(emailInput.val())) {
          errorMessages.filter('#error-book-email').css('display', 'block');
          emailInput.addClass('error');
          isEmptyField = 1;
        }
        if (
          (signUpPrivacy === '' && !termsPrivacyRadio) ||
          (signUpPrivacy === '' && oab_privacy_mandatory)
        ) {
          errorMessages.filter('#error-signup-privacy-invalid').css('display', 'block');
          signUpPrivacyContainer.find('span.label, .picker-handle').addClass('error');
          signUpPrivacyContainer.addClass('error');
          signUpPrivacyInput.addClass('error');
          isEmptyField = 1;
        }
        if (krFormat) {
          if (phone_full_length && !phone_zero_length_regex.test(phone_full_length)) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
          if (!apptKrSelectPhoneCode.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          } else {
            apptKRPhoneCode.removeClass('error');
          }
          if (phone1Input.val()) {
            if (phone1_regex && !phone1_regex.test(phone1Input.val())) {
              errorMessages.filter('#error-book-mobile').css('display', 'block');
              errorMessages.filter('#error-book-mobile_part1_invalid').css('display', 'block');
              apptKRPhoneCode.addClass('error');
              phone1Input.addClass('error');
              phone2Input.addClass('error');
              isEmptyField = 1;
            }
          } else if (!phone1Input.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
          if (phone2Input.val()) {
            if (phone2_regex && !phone2_regex.test(phone2Input.val())) {
              errorMessages.filter('#error-book-mobile').css('display', 'block');
              errorMessages.filter('#error-book-mobile_part2_invalid').css('display', 'block');
              apptKRPhoneCode.addClass('error');
              phone1Input.addClass('error');
              phone2Input.addClass('error');
              isEmptyField = 1;
            }
          } else if (!phone2Input.val()) {
            errorMessages.filter('#error-book-mobile').css('display', 'block');
            apptKRPhoneCode.addClass('error');
            phone1Input.addClass('error');
            phone2Input.addClass('error');
            isEmptyField = 1;
          }
        } else {
          if (!phoneInput.val() && errorMessages.filter('#error-signup-sms').is(':hidden')) {
            errorMessages.filter('#error-book-phone').css('display', 'block');
            phoneInput.addClass('error');
            isEmptyField = 1;
          } else if (!phone_regex.test(phone)) {
            phoneInput.addClass('error');
            errorContainer.css('display', 'block');
            errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
            isEmptyField = 1;
          }
        }
        if (oab_legal_statement_promotions) {
          if (!termsPrivacyRadio.is(':checked')) {
            errorMessages.filter('#error-oab-accept-privacy-policy').css('display', 'block');
            termsPrivacyRadioLabel.addClass('error');
            isEmptyField = 1;
          } else if (
            termsPrivacyRadio.is(':checked') &&
            $('input[name=ACCEPTED_PRIVACY_POLICY]:checked').val() === '0'
          ) {
            errorMessages.filter('#error-oab-accept-privacy-policy').css('display', 'block');
            termsPrivacyRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsPrivacyRadioLabel.removeClass('error');
          }
          if (!termsSMSNotificationsRadio.is(':checked')) {
            errorMessages.filter('#error-oab-sms-notifications').css('display', 'block');
            termsSMSNotificationsRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsSMSNotificationsRadioLabel.removeClass('error');
          }
          if (!termsEmailPromotionsRadio.is(':checked')) {
            errorMessages.filter('#error-oab-pc-email-promotions').css('display', 'block');
            termsEmailPromotionsRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsEmailPromotionsRadioLabel.removeClass('error');
          }
          if (!termsSMSPromotionsRadio.is(':checked')) {
            errorMessages.filter('#error-oab-pc-email-promotions').css('display', 'block');
            termsSMSPromotionsRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsSMSPromotionsRadioLabel.removeClass('error');
          }
          if (!termsPostalRadio.is(':checked')) {
            errorMessages.filter('#error-oab-pc-email-promotions').css('display', 'block');
            termsPostalRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsPostalRadioLabel.removeClass('error');
          }
          if (!termsThirdPartyPromotionRadio.is(':checked')) {
            errorMessages.filter('#error-oab-third-party-promotions').css('display', 'block');
            termsThirdPartyPromotionRadioLabel.addClass('error');
            isEmptyField = 1;
          } else {
            termsThirdPartyPromotionRadioLabel.removeClass('error');
          }
        }
      }

      function onBookSuccess(r) {
        var updateData,
          apptId = r.id;

        site?.track?.evtView && site.track.evtView({
          page_url: '/book-appointment/complete',
          location: location.origin + '/book-appointment/complete',
          page_name: 'Book Appointment - Complete'
        });

        site?.track?.evtLink && site.track.evtLink({
          event_name: 'appointmentBooking_complete',
          event_category: 'appointment booking',
          event_action: 'appointment booked',
          event_label: r.counter.store_no + ' - ' + r.counter.name + ' - ' + r.start_time
        });

        updateData = {
          sectionId: 'next',
          params: r
        };
        me.model.update(updateData);
        errorMessages.css('display', 'none');
        errorContainer.css('display', 'none');
        me.container.find('input, textarea, .label, .picker-handle').removeClass('error');
      }

      function onBookError(r) {
        $this.removeClass('disabled');

        var errFName = r.customer_first_name,
          errLName = r.customer_last_name,
          errEmail = r.customer_email,
          errPhone = r.customer_phone;

        errorContainer.css('display', 'block');
        errorMessages.css('display', 'none');

        if (r.code === 500 || r.code === '500') {
          me.launchBookConflictOverlay();

          return;
        }

        if (errFName && errFName.length) {
          errorMessages.filter('#error-book-first-name').css('display', 'block');
          fNameInput.addClass('error');
        }
        if (errLName && errLName.length) {
          errorMessages.filter('#error-book-last-name').css('display', 'block');
          lNameInput.addClass('error');
        }
        if (errEmail && errEmail.length) {
          errorMessages.filter('#error-book-email').css('display', 'block');
          emailInput.addClass('error');
        }
        if (errPhone && errPhone.length) {
          errorMessages.filter('#error-book-phone').css('display', 'block');
          phoneInput.addClass('error');
        }
      }

      function doBooking() {
        errorMessages.css('display', 'none');
        me.container.find('input, textarea, .label, .picker-handle').removeClass('error');

        if (isEmptyField) {
          $this.removeClass('disabled');
        } else if (me.updateMode && me.appointmentId) {
          me.model.changeAppointment(me.appointmentId, params, onBookSuccess, onBookError);
        } else {
          me.model.bookAppointment(params, onBookSuccess, onBookError);
        }
      }
      signUpEmailObj._SUBMIT = 'email_signup';
      signUpEmailObj.EMAIL_ADDRESS = email;
      signUpEmailObj.PC_EMAIL_ADDRESS = email;
      signUpEmailObj.FIRST_NAME = fNameInput.val();
      signUpEmailObj.LAST_NAME = lNameInput.val();
      signUpEmailObj.LAST_SOURCE = 'appointment_booking_reg';

      if (rpw.attr('disabled') || rpw.val() === '') {
        if (!signUpEmail) {
          if (!oab_legal_statement_promotions) {
            signUpEmailObj.ACTION = 'unset';
          } else {
            signUpEmailObj.ACTION = '';
          }
        }
      }

      if (oab_email_promotions) {
        signUpEmailObj.PC_EMAIL_PROMOTIONS = 1;
      }

      if (!rpw.attr('disabled') && rpw.val() !== '') {
        signUpEmailObj._SUBMIT = reg_form_name;
        signUpEmailObj.PASSWORD = rpw.val();
        signUpEmailObj.PASSWORD2 = rpw.val();
        signUpEmailObj.PC_EMAIL_ADDRESS2 = email;
        signUpEmailObj.ACCEPTED_PRIVACY_POLICY = signUpPrivacy; // 1;
        signUpEmailObj.CAN_ADD_ADDRESS = 0;
        if (signUpEmail) {
          signUpEmailObj.PC_EMAIL_PROMOTIONS = 1;
        }
        if (kr_registration) {
          signUpEmailObj.AGE_RESTRICTION = 1;
          signUpEmailObj.FULL_NAME = fNameInput.val();
          signUpEmailObj.MOBILE_AREA_CODE = apptKrSelectPhoneCode.val();
          signUpEmailObj.MOBILE_PART1 = phone1Input.val();
          signUpEmailObj.MOBILE_PART2 = phone2Input.val();
          signUpEmailObj.ACCEPT_TERMS = parseInt(termsPrivacyRadio.val()) ? 'Y' : 'N';
          signUpEmailObj.ACCEPT_PRIVACY = parseInt(termsPrivacyRadio.val()) ? 'Y' : 'N';
          signUpEmailObj.MOBILE_STATUS = 1;
        }
      }
      if (oab_legal_statement_promotions) {
        signUpEmailObj.LAST_SOURCE = 'appointment_booking';
        signUpEmailObj.ORIGINAL_SOURCE = 'appointment_booking';
        signUpEmailObj.suppress_conf_email = 1;
        signUpEmailObj.ACCEPTED_PRIVACY_POLICY = 1;
        if (oabTermsThirdPartyPromotionRadio === '1') {
          signUpEmailObj.PC_EMAIL_PROMOTIONS = oabTermsEmailPromotionsRadio;
          if (oabTermsSMSPromotionsRadio === '1') {
            signUpEmailObj.MOBILE_NUMBER =
              apptKrSelectPhoneCode.val() + '-' + phone1Input.val() + '-' + phone2Input.val();
            signUpEmailObj.MOBILE_PHONE = signUpEmailObj.MOBILE_NUMBER;
          }
          signUpEmailObj.SMS_PROMOTIONS = oabTermsSMSPromotionsRadio;
          signUpEmailObj.POSTAL_PROMOTIONS = oabTermsPostalRadio;
          signUpEmailObj.ACCEPTED_THIRD_PARTY = oabTermsThirdPartyPromotionRadio;
        } else {
          signUpEmailObj.ACTION = 'unset';
          signUpEmailObj.PC_EMAIL_PROMOTIONS = '0';
          signUpEmailObj.SMS_PROMOTIONS = '0';
          signUpEmailObj.POSTAL_PROMOTIONS = '0';
          signUpEmailObj.ACCEPTED_THIRD_PARTY = '0';
        }
      }
      if (signUpSMS && (!me.userData || !me.userData.sms_optin)) {
        signUpEmailObj._SECONDARY_SUBMIT = 'sms';
        signUpEmailObj.MOBILE_PHONE = phone;
        signUpEmailObj.SMS_PROMOTIONS = 1;
      }

      if (!signUpSMS && !ommit_sms) {
        signUpEmailObj._SECONDARY_SUBMIT = 'sms';
        signUpEmailObj.PHONE2 = phone;
        signUpEmailObj.SMS_PROMOTIONS = 0;
      }

      signUpEmailParams.push(signUpEmailObj);

      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: JSON.stringify(signUpEmailParams),
        onSuccess: function (jsonRpcResponse) {
          signUpEmailDone = true;
          doBooking();
        },
        onFailure: function (jsonRpcResponse) {
          var errObjs = jsonRpcResponse.getMessages();
          var errorMessagePasswordId = '';

          errorContainer.css('display', 'block');
          errorMessages.css('display', 'none');
          me.container.find('input, textarea, .label, .picker-handle').removeClass('error');

          for (var i = 0; i < errObjs.length; i += 1) {
            var myErr = errObjs[i];

            if (myErr && myErr.key) {
              if (
                myErr.key === 'required.pc_email_address.email_signup' ||
                myErr.key === 'invalid.pc_email_address.email_signup' ||
                myErr.key === 'required.pc_email_address.email_signup.app' ||
                myErr.key === 'invalid.pc_email_address.email_signup.app'
              ) {
                emailInput.addClass('error');
                errorMessages.filter('#error-signup-email').css('display', 'block');
              }

              if (
                myErr.key === 'required_dependency.sms_promotions.mobile_phone.dependency.sms' ||
                myErr.key === 'required_dependency.sms_promotions.mobile_phone.dependency.sms.app'
              ) {
                phoneInput.addClass('error');
                errorMessages.filter('#error-signup-sms').css('display', 'block');
              }

              if (
                myErr.key === 'invalid.mobile_phone.sms' ||
                myErr.key === 'invalid.mobile_phone.sms.app'
              ) {
                phoneInput.addClass('error');
                errorMessages.filter('#error-signup-sms-invalid').css('display', 'block');
              }

              if (
                (myErr.key === 'required.password.' + reg_form_name ||
                  myErr.key === 'required.password.' + reg_form_name + '.app') &&
                errorMessagePasswordId !== 'error-register-min-max-password'
              ) {
                rpw.addClass('error');
                errorMessagePasswordId = 'error-register-password';
                errorMessages.filter('#error-register-password').css('display', 'block');
                errorMessages.filter('#error-register-min-max-password').css('display', 'none');
              }

              if (
                (myErr.key === 'invalid.password.' + reg_form_name ||
                  myErr.key === 'invalid.password.' + reg_form_name + '.app') &&
                errorMessagePasswordId !== 'error-register-min-max-password'
              ) {
                rpw.addClass('error');
                errorMessagePasswordId = 'error-register-invalid-password';
                errorMessages.filter('#error-register-invalid-password').css('display', 'block');
                errorMessages.filter('#error-register-password').css('display', 'none');
                errorMessages.filter('#error-register-min-max-password').css('display', 'none');
              }

              if (
                myErr.key === 'min_max.password.' + reg_form_name ||
                myErr.key === 'min_max.password.' + reg_form_name + '.app' ||
                myErr.key === 'format.password.' + reg_form_name
              ) {
                rpw.addClass('error');
                errorMessagePasswordId = 'error-register-min-max-password';
                errorMessages.filter('#error-register-min-max-password').css('display', 'block');
                errorMessages.filter('#error-register-invalid-password').css('display', 'none');
                errorMessages.filter('#error-register-password').css('display', 'none');
              }

              if (
                myErr.key === 'required.pc_email_address.' + reg_form_name ||
                myErr.key === 'invalid.pc_email_address.' + reg_form_name ||
                myErr.key === 'required.pc_email_address.' + reg_form_name + '.app' ||
                myErr.key === 'invalid.pc_email_address.' + reg_form_name + '.app'
              ) {
                emailInput.addClass('error');
                errorMessages.filter('#error-book-email').css('display', 'block');
              }

              if (
                myErr.key === 'required.accepted_privacy_policy.' + reg_form_name ||
                myErr.key === 'invalid.accepted_privacy_policy.' + reg_form_name ||
                myErr.key === 'required.accepted_privacy_policy.' + reg_form_name + '.app' ||
                myErr.key === 'invalid.accepted_privacy_policy.' + reg_form_name + '.app' ||
                signUpPrivacy === ''
              ) {
                signUpPrivacyInput.addClass('error');
                signUpPrivacyContainer.find('span.label, .picker-handle').addClass('error');
                errorMessages.filter('#error-signup-privacy-invalid').css('display', 'block');
              }

              if (
                myErr.key === 'invalid.accepted_privacy_policy.' + reg_form_name ||
                myErr.key === 'invalid.accepted_privacy_policy.' + reg_form_name + '.app'
              ) {
                emailInput.addClass('error');
                errorMessages.filter('#error-book-email').css('display', 'block');
                errorMessages.filter('#error-register-password').css('display', 'block');
              }

              if (myErr.key === 'account_exists' || myErr.key === 'account_exists.app') {
                emailInput.addClass('error');
                errorMessages.filter('#error-register-account-exist').css('display', 'block');
              }
            }
          }

          $this.removeClass('disabled');
          generic.focusErrors(errorContainer, $('.js-booking-step3'));
        }
      });
    }
  };

  apptBook.confirmAccount.prototype.launchBookConflictOverlay = function () {
    var me = this;

    this.jqBod.prepend(this.bookConflictOverlay);
    this.bookConflictOverlay.show();
    this.bookConflictOverlay.click(function (e) {
      e.preventDefault();
      me.bookConflictOverlay.off('click');
      me.bookConflictOverlay.remove();
    });
  };

  Drupal.behaviors.apptBookconfirmAccount = {
    attach: function (context) {
      var view = new apptBook.confirmAccount($('#confirm'));

      view.setModel(apptBook.sectionModel).startObserving();
    }
  };
})(jQuery);
